import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './object_header.scss';

const ObjectHeader = props => {
  const { objectType, objectName, title, children } = props;
  return (
    <div className="object-header">
      <div className="object-title">
        <div className="object-icon">
          {objectType && <i className={classnames('object-overview-icon', objectType)} />}
          {objectName && <div className="object-type">{objectName}</div>}
        </div>
        <div className="object-name">{title}</div>
      </div>

      {children && <div className="d-none d-lg-flex">{children}</div>}
    </div>
  );
};

ObjectHeader.propTypes = {
  objectType: PropTypes.string,
  objectName: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node,
};

export default ObjectHeader;
